import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import ClienteActions from "../../clientes/components/ClienteActions.js";
import { postGrabar, clienteBoletaGrabar, getCotizacion } from "../../../service/AffariService.js";

const Cabecera = ({
    tipo,
    data,
    setData,
    setCodigo,
    setIdCotizacion,
    setIsContactoDialogVisible,
    setIsDatosDialogVisible,
    setIsDeudaDialogVisible,
    setIsVentaDialogVisible,
    setIsTicketsDialogVisible,
    setIsSincronizarDialogVisible,
    setCollapsedClient,
    setCollapsedFolio,
    setIsDetalleVisible,
    toastRef
}) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const toast = toastRef ;
    
    const selectdatos = (rowData) => {
        setIsDatosDialogVisible(true);
        setCodigo(rowData.cliente.codigo);
    }

    const selectdeuda = (rowData) => {
        setIsDeudaDialogVisible(true);
        setCodigo(rowData.cliente.codigo);
    }

    const selectventa = (rowData) => {
        setIsVentaDialogVisible(true);
        setCodigo(rowData.cliente.codigo);
    }

    const selecttickets = (rowData) => {
        setIsTicketsDialogVisible(true);
        setCodigo(rowData.cliente.codigo);
    }

    const [loadingCotizacion, setLoadingCotizacion] = useState(false);

    const selectActualizar = async (rowData) => {
        const codigoCli = rowData?.cliente?.codigo;
        setCodigo(codigoCli);
        if (typeof setIsSincronizarDialogVisible === 'function') {
            setIsSincronizarDialogVisible(true);
        } else if (codigoCli) {
            try {
                setLoadingCotizacion(true);
                await getCotizacion(codigoCli);
                toast?.current?.show({ severity: 'success', summary: 'Cotización actualizada',life: 3000 });
            } catch (error) {
                toast?.current?.show({ severity: 'error', summary: 'Cotización', detail: 'No se pudo actualizar la cotización', life: 3000 });
            } finally {
                setLoadingCotizacion(false);
            }
        }
    }

    const cotizacionNormal = async () => {
        setLoading(true);
        if (!data.cliente?.codigo) {
            toast.current?.show({ severity: 'warn', summary: 'Cliente', detail: 'Selecciona un cliente antes de continuar.', life: 3000 });
            return;
        }
        if (!(data.estado?.id || data.estado)) {
            toast.current?.show({ severity: 'warn', summary: 'Estado', detail: 'Selecciona el estado de la cotización.', life: 3000 });
            return;
        }
        if (!(data.validez || data.validezs?.[0]?.id)) {
            toast.current?.show({ severity: 'warn', summary: 'Validez', detail: 'Selecciona la validez de la oferta.', life: 3000 });
            return;
        }

        try {
            let idDatoClienteBoleta;
            const esBoleta = data.documento === 'Boleta' || data.documento === 'ZBOE';
            if (esBoleta && data.clienteBoleta) {
                if (!data.clienteBoleta.correo || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.clienteBoleta.correo) 
                    ) {
                    setLoading(false);
                    if (toast.current) toast.current.show({ severity: 'warn', summary: 'Datos incompletos', detail: 'Ingresa un correo electrónico válido.', life: 3000 });
                    return;
                }

                if (!data.clienteBoleta.nombre || !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(data.clienteBoleta.nombre)) {
                    setLoading(false);
                    if (toast.current) toast.current.show({ severity: 'warn', summary: 'Datos incompletos', detail: 'Ingresa un nombre válido.', life: 3000 });
                    return;
                }
                
                if (!data.clienteBoleta.telefono) {
                    setLoading(false);
                    if (toast.current) toast.current.show({ severity: 'warn', summary: 'Datos incompletos', detail: 'Ingresa un teléfono válido.', life: 3000 });
                    return;
                }

                const r = await clienteBoletaGrabar(
                    data.clienteBoleta.correo,
                    data.clienteBoleta.nombre,
                    data.clienteBoleta.telefono
                );
                if (r?.resultado && r?.id) {
                    idDatoClienteBoleta = r.id;
                    toast.current?.show({ severity: 'success', summary: 'Cliente Boleta', detail: 'Datos de boleta registrados con éxito.', life: 3500 });
                } else {
                    toast.current?.show({ severity: 'error', summary: 'Cliente Boleta', detail: 'No se pudo registrar los datos de boleta.', life: 3500 });
                    return;
                }
            }

            const response = await postGrabar({
                id_cotizacion: data.tipoCotizacion,
                cliente: data.cliente?.codigo,
                id_estado: data.estado?.id || data.estado,
                id_lista_precio: data.cliente?.listaPrecio?.codigo,
                id_almacen: data.cliente?.listaPrecio?.almacen,
                fecha_decision: data.fecha,
                fecha_entrega: data.fecha,
                obra: "0",
                proyecto: data.proyecto || "0",
                contacto: 101,
                condicion: "3",
                validez: data.validez || data.validezs?.[0]?.id,
                documento: esBoleta ? 'ZBOE' : (data.documento === 'Factura' ? 'ZSDE' : data.documento),
                id_dato_cliente_boleta: idDatoClienteBoleta || 0
            });
            if (response?.cotizacion && response?.resultado) {
                setIdCotizacion(response.cotizacion);
                if (setCollapsedClient) setCollapsedClient(true);
                if (setCollapsedFolio) setCollapsedFolio(false);

                try {
                    setData(prevData => ({
                        ...prevData,
                        idCotizacion: response.cotizacion,
                        codigo: response.cotizacion
                    }));
                    setIsDetalleVisible(true);
                } catch (error) {
                    console.error("Error al cargar datos adicionales de la cotización:", error);
                }

                toast.current?.show({ severity: 'success', summary: 'Cotización', detail: `Cotización ${response.cotizacion} creada.`, life: 3000 });
            } else {
                toast.current?.show({ severity: 'error', summary: 'Cotización', detail: 'No se pudo crear la cotización.', life: 3500 });
            }
        } catch (error) {
            console.error("Error al crear/actualizar la cotización:", error);
            toast.current?.show({ severity: 'error', summary: 'Cotización', detail: 'Ocurrió un error al procesar la cotización.', life: 3500 });
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="col-12">
            {!toastRef && <Toast ref={toast} position="top-right" baseZIndex={3000} appendTo={document.body} />}
            {/* SECCIÓN 1: CLIENTE, CONTACTO Y DOCUMENTO */}
            <div className="grid align-items-start mb-3 border-bottom-1 surface-border pb-3">
                <div className="col-12 md:col-3 border-right-1 surface-border">
                    <div className="text-900 font-bold text-xl mb-2">
                        {data.cliente ? `${data.cliente.codigo} - ${data.cliente.razonSocial}` : 'No seleccionado'}
                    </div>
                    {data.cliente && (
                        <div className="text-600 text-sm">
                            <i className="pi pi-id-card mr-1"></i>{data.cliente.rut}
                            <span className="mx-2 text-300">|</span>
                            <i className="pi pi-map-marker mr-1"></i>{data.cliente.direccion}
                        </div>
                    )}
                    <div className="mt-3">
                        <ClienteActions
                            step="cotizacion"
                            rowData={data}
                            onSelectDatos={selectdatos}
                            onSelectDeuda={selectdeuda}
                            onSelectTickets={selecttickets}
                            onSelectVenta={selectventa}
                            onActualizarCliente={selectActualizar}
                            loadingCotizacion={loadingCotizacion}
                        />
                    </div>
                </div>
                
                <div className="col-12 md:col-9 pl-4">
                    <div className="grid p-fluid">
                        <div className="col-12 md:col-4">
                            <label htmlFor="contacto" className="text-500 font-medium text-xs block mb-1">Contacto</label>
                            <div className="p-inputgroup h-2rem">
                                <Dropdown
                                    id="contacto"
                                    value={data.contacto}
                                    options={data.contactos || []}
                                    optionLabel={(contacto) => `${contacto.nombre} - ${contacto.email}`}
                                    placeholder="Seleccionar"
                                    className="p-inputtext-sm"
                                    onChange={(e) => setData({ ...data, contacto: e.value })}
                                />
                                <Button 
                                    icon="pi pi-plus" 
                                    className="p-button-outlined p-button-primary p-button-sm" 
                                    onClick={() => setIsContactoDialogVisible(true)} 
                                />
                            </div>
                        </div>

                        {data.interfaz !== 'MAYORISTA' && ( 
                            <>
                                <div className="col-12 md:col-8">
                                    <label className="text-500 font-medium text-xs block mb-1">Tipo de Documento</label>
                                    <div className="flex flex-column md:flex-row align-items-start md:align-items-center gap-2 md:gap-4">
                                        <div className={tipo === 'factura' ? 'hidden' : ''}>
                                            <RadioButton inputId="doc_Boleta" name="documento" value="ZBOE" 
                                                onChange={(e) => setData({ ...data, documento: e.value })} 
                                                checked={data.documento === 'ZBOE' || data.documento === 'Boleta'} 
                                            />
                                            <label htmlFor="doc_Boleta" className="ml-2 text-sm cursor-pointer text-900">Boleta</label>
                                        </div>
                                        <div className="flex align-items-center">
                                            <RadioButton inputId="doc_Factura" name="documento" value="ZSDE" 
                                                onChange={(e) => {
                                                    if (tipo === 'boleta') {
                                                        if (window.confirm("Será redireccionado a la sección de Factura. ¿Desea continuar?")) {
                                                            navigate('/factura');
                                                        }
                                                    }else{
                                                        setData({ ...data, documento: e.value });
                                                    }
                                                }} 
                                                checked={data.documento === 'ZSDE' || data.documento === 'Factura'} 
                                            />
                                            <label htmlFor="doc_Factura" className="ml-2 text-sm cursor-pointer text-900">Factura</label>
                                        </div>
                                            {(['ZSDE', 'ZSME', 'ZFME', 'ZVTS', 'ZVFX', 'Factura'].includes(data.documento)) && (
                                            <>
                                                <div className="flex align-items-center">
                                                    <RadioButton inputId="doc_GuiaFactura" name="documento" value="ZSME"  
                                                        onChange={(e) => setData({ ...data, documento: e.value })}
                                                        checked={data.documento === 'ZSME'}
                                                    />
                                                    <label htmlFor="doc_GuiaFactura" className="ml-2 text-sm cursor-pointer text-900">Guia / Factura</label>
                                                </div>

                                                <div className="flex align-items-center">
                                                    <RadioButton inputId="doc_VentaCalzada" name="documento" value="ZFME"  
                                                        onChange={(e) => setData({ ...data, documento: e.value })}
                                                        checked={data.documento === 'ZFME'}
                                                    />
                                                    <label htmlFor="doc_VentaCalzada" className="ml-2 text-sm cursor-pointer text-900">Venta Calzada</label>
                                                </div>

                                                <div className="flex align-items-center">
                                                    <RadioButton inputId="doc_ServicioSack" name="documento" value="ZVTS"  
                                                        onChange={(e) => setData({ ...data, documento: e.value })}
                                                        checked={data.documento === 'ZVTS'}
                                                    />
                                                    <label htmlFor="doc_ServicioSack" className="ml-2 text-sm cursor-pointer text-900">Servicio Sack</label>
                                                </div>

                                                <div className="flex align-items-center">
                                                    <RadioButton inputId="doc_Exportacion" name="documento" value="ZVFX"  
                                                        onChange={(e) => setData({ ...data, documento: e.value })}
                                                        checked={data.documento === 'ZVFX'}
                                                    />
                                                    <label htmlFor="doc_Exportacion" className="ml-2 text-sm cursor-pointer text-900">Exportación</label>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

                        {data.documento === 'Boleta' && (
                            <div className="col-12 ">
                                <div>
                                    <label className="text-500 font-medium text-xs block mb-1">Datos Cliente Boleta</label>
                                    <div className="flex gap-2">
                                        <div className="flex-grow-1">
                                            <span className="p-input-icon-left w-full">
                                                <i className="pi pi-user text-sm" />
                                                <InputText
                                                    value={data.clienteBoleta?.nombre || ''}
                                                    onChange={(e) => setData({ ...data, clienteBoleta: { ...data.clienteBoleta, nombre: e.target.value } })}
                                                    placeholder="Nombre"
                                                    className="w-full p-inputtext-sm"
                                                />
                                            </span>
                                        </div>
                                        <div className="flex-grow-1">
                                            <span className="p-input-icon-left w-full">
                                                <i className={`pi ${data.clienteBoleta?.correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.clienteBoleta.correo) ? 'pi-exclamation-circle text-red-500' : 'pi-envelope'} text-sm`} />
                                                <InputText
                                                    value={data.clienteBoleta?.correo || ''}
                                                    onChange={(e) => setData({ ...data, clienteBoleta: { ...data.clienteBoleta, correo: e.target.value } })}
                                                    placeholder="Correo"
                                                    className={`w-full p-inputtext-sm ${data.clienteBoleta?.correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.clienteBoleta.correo) ? 'p-invalid' : ''}`}
                                                />
                                            </span>
                                        </div>
                                        <div className="flex-grow-1">
                                            <span className="p-input-icon-left w-full">
                                                <i className={`pi ${data.clienteBoleta?.telefono && !/^\+56\d{9}$/.test(data.clienteBoleta.telefono) ? 'pi-exclamation-circle text-red-500' : 'pi-phone'} text-sm`} />
                                                <InputText
                                                    value={data.clienteBoleta?.telefono || '+56'}
                                                    onChange={(e) => {
                                                        let val = e.target.value;
                                                        if (!val.startsWith('+56')) {
                                                            // Si borra el prefijo, intentamos recuperarlo o reiniciarlo
                                                            const nums = val.replace(/\D/g, '');
                                                            val = '+56' + nums;
                                                        } else {
                                                            // Mantiene formato +56XXXXXXXXX
                                                            val = '+56' + val.substring(3).replace(/\D/g, '');
                                                        }
                                                        if (val.length > 12) return; // +56 + 9 dígitos
                                                        setData({ ...data, clienteBoleta: { ...data.clienteBoleta, telefono: val } });
                                                    }}
                                                    placeholder="Teléfono"
                                                    className={`w-full p-inputtext-sm ${data.clienteBoleta?.telefono && !/^\+56\d{9}$/.test(data.clienteBoleta.telefono) ? 'p-invalid' : ''}`}
                                                />
                                            </span>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* SECCIÓN 2: CONFIGURACIÓN DE LA VENTA */}
            <div className="mb-3 border-bottom-1 surface-border pb-3">
                <div className="text-900 font-bold text-sm mb-2">Configuración de Venta</div>
                <div className="grid p-fluid">
                    <div className="col-12 md:col-4">
                        <label htmlFor="proyecto" className="text-500 font-medium text-xs block mb-1">Proyecto</label>
                        <Dropdown
                            id="proyecto"
                            value={data.proyecto?.id || data.proyecto}
                            onChange={(e) => setData({ ...data, proyecto: e.value })}
                            options={data.proyectos || []}
                            optionLabel="descripcion"
                            optionValue="id"
                            placeholder="Seleccionar"
                            className="w-full p-inputtext-sm"
                        />
                    </div>
                    <div className="col-12 md:col-4">
                        <label htmlFor="estado" className="text-500 font-medium text-xs block mb-1">Estado</label>
                        <Dropdown
                            id="estado"
                            value={data.estado?.id || data.estado}
                            onChange={(e) => setData({ ...data, estado: e.value })}
                            options={data.estados || []}
                            optionLabel="descripcion"
                            optionValue="id"
                            placeholder="Seleccionar"
                            className="w-full p-inputtext-sm"
                            itemTemplate={(option) => (
                                <span className={`status-badge status-${option.descripcion.toLowerCase()}`}>{option.descripcion}</span>
                            )}
                        />
                    </div>
                    <div className="col-12 md:col-4">
                        <label htmlFor="validez" className="text-500 font-medium text-xs block mb-1">Validez Oferta</label>
                        <Dropdown
                            id="validez"
                            value={data.validez || data.validezs?.[0]?.id}
                            onChange={(e) => setData({ ...data, validez: e.value })}
                            options={data.validezs || []}
                            optionLabel="descripcion"
                            optionValue="id"
                            placeholder="Seleccionar"
                            className="w-full p-inputtext-sm"
                            itemTemplate={(option) => (
                                <span className={`status-badge status-${option.descripcion.toLowerCase()}`}>{option.descripcion}</span>
                            )}
                        />
                    </div>
                    {data.interfaz === 'MAYORISTA' && (
                        <>
                            <div className="col-12 md:col-4">
                                <label htmlFor="centro" className="text-500 font-medium text-xs block mb-1">Centro</label>
                                <Dropdown
                                    id="centro"
                                    options={data.almacens || []}
                                    optionLabel="sucursal"
                                    placeholder="Seleccionar"
                                    className="w-full p-inputtext-sm"
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label htmlFor="fecha decision" className="text-500 font-medium text-xs block mb-1">Fecha Decisión</label>
                                <Calendar
                                    id="fecha decision"
                                    value={data.fechaDecision}
                                    onChange={(e) => setData({ ...data, fechaDecision: e.value })}
                                    className="w-full p-inputtext-sm"
                                    minDate={new Date()}
                                />
                            </div>
                            
                            <div className="col-12 md:col-4">
                                <label htmlFor="fecha entrega" className="text-500 font-medium text-xs block mb-1">Fecha Entrega</label>
                                <Calendar
                                    id="fecha entrega"
                                    value={data.fechaEntrega}
                                    onChange={(e) => setData({ ...data, fechaEntrega: e.value })}
                                    className="w-full p-inputtext-sm"
                                    minDate={new Date()}
                                />
                            </div>

                        </>
                    )}
                </div>
            </div>

            {/* SECCIÓN 3: DETALLES INFORMATIVOS (READ ONLY) */}
            <div className="surface-100 p-2 border-round mb-3">
                <div className="flex flex-wrap gap-4 row-gap-2 text-sm">
                    <div>
                        <span className="text-500 font-medium mr-1">Vendedor:</span>
                        <span className="text-900 font-bold">
                            {data.cliente?.vendedor ? `${data.cliente.vendedor.codigo} - ${data.cliente.vendedor.descripcion}` : '-'}
                        </span>
                    </div>
                    <div>
                        <span className="text-500 font-medium mr-1">Oficina de Venta:</span>
                        <span className="text-900 font-bold">{data.almacen?.oficina || '-'}</span>
                    </div>
                    <div>
                        <span className="text-500 font-medium mr-1">Lista Precio:</span>
                        <span className="text-900 font-bold">{data.cliente?.listaPrecio?.descripcion || '-'}</span>
                    </div>
                    <div>
                        <span className="text-500 font-medium mr-1">Condición Pago:</span>
                        <span className="text-900 font-bold">
                            {data.cliente?.condicionPago
                                ? `${data.cliente.condicionPago.descripcion}`
                                : 'E000'}
                        </span>
                    </div>

                    {data.interfaz !== 'MAYORISTA' && (
                        <>
                            <div>
                                <span className="text-500 font-medium mr-1">Centro:</span>
                                <span className="text-900 font-bold">
                                    {data.almacen?.almacen || 'No'} - {data.almacen?.sucursal || 'Definido'}
                                </span>
                            </div>
                        
                            <div>
                                <span className="text-500 font-medium mr-1">F. Decisión:</span>
                                <span className="text-900 font-bold">{data.fecha || '-'}</span>
                            </div>
                            <div>
                                <span className="text-500 font-medium mr-1">F. Entrega:</span>
                                <span className="text-900 font-bold">{data.fecha || '-'}</span>
                            </div>
                        </>
                    )}
                </div>
            </div>
            
            {data.interfaz !== 'MAYORISTA' && (
                <div className="flex col-12 justify-content-center gap-2">
                <Button label="Cotización Normal" className="p-button-primary p-button-sm w-5" icon={loading? "pi pi-spin pi-spinner" : "pi pi-check"} onClick={() => { cotizacionNormal() }} />
            </div>
            )}
            {data.interfaz === 'MAYORISTA' && (
                <div className="flex col-12 justify-content-center gap-2">
                    <Button label="Cotización Normal" className="p-button-primary p-button-sm" icon={loading? "pi pi-spin pi-spinner" : "pi pi-check"} onClick={() => { cotizacionNormal() }} />
                    <Button label="Cotización Especial" className="p-button-success p-button-sm" icon="pi pi-check" />
                </div>
            )}
        </div>
    );
};

export default Cabecera;